module.exports = __webpack_public_path__ + "img/taketomi_11.704bbab7.jpg";